import React, { useMemo, useState } from 'react';
// import classnames from 'classnames';
import { useRequest } from 'ahooks';
// import { IChartProps, MarkerCallback } from 'bizcharts/lib/interface';
import { IChartProps } from 'bizcharts/lib/interface';
import { useSelector } from 'react-redux';
import { ConHomeWebController } from '@/services/swagger/ConHomeWebController';
import { ConHomeIndustryHeader } from '@/services/swagger/data-contracts';
import LineAndBarMixedChart from '@/components/charts/LineAndBarMixedChart';
import { RootState } from '@/models';
// import { formatNumberValueToChineseUnit } from '@/utils/format';
import TooltipBase from '@/components/tooltip';
import ChartHeader from '../chart-header';
import Chart from '../chart';
// import CustomEmpty from '../CustomEmpty';
// import IndustryScaleMoMRatioPanelVersionTwo from '../IndustryScaleMoMRatioPanelVersionTwo';
import IndustryLabel from './IndustryLabel';
// import IndustryCompositeIndexList from './IndustryCompositeIndexList';
// import RacetrackCompositeIndexROICard from './RacetrackCompositeIndexROICard';
// import IndustryScaleMoMRatioPanel from './IndustryScaleMoMRatioPanel';
// import IndustryDiscussionCloutMoMRatioPanelVersionTwo from './IndustryDiscussionCloutMoMRatioPanelVersionTwo';
import styles from './index.module.scss';

// const scale: IChartProps['scale'] = {
//   countTimeYear: {
//     type: 'cat',
//     alias: '年份',
//     formatter(value) {
//       return `${value}年`;
//     },
//   },
//   increaseVaue: {
//     type: 'linear',
//     // min: 0,
//     // max: 100,
//     // tickCount: 2,
//     nice: true,
//     alias: '规模同比',
//     formatter(value) {
//       return `${value}%`;
//     },
//   },
//   scaleValue: {
//     type: 'linear',
//     //   tickCount: 2,
//     nice: true,
//     alias: '行业消费规模',
//     // formatter(v) {
//     //   const { unit, value } = formatNumberValueToChineseUnit(v, 2);
//     //   return `${value}${unit}`;
//     // },
//   },
// };

// const cloutScale: IChartProps['scale'] = {
//   countTimeMonth: {
//     type: 'cat',
//     alias: '月份',
//     sync: true,
//     formatter(value) {
//       return `${value}月`;
//     },
//   },
//   increaseRateValue: {
//     type: 'linear',
//     // min: 0,
//     // max: 100,
//     tickCount: 2,
//     nice: true,
//     alias: '行业讨论热度环比',
//     formatter(value) {
//       // console.log(value);
//       return `${value}%`;
//     },
//   },
//   discussValue: {
//     type: 'linear',
//     //   tickCount: 2,
//     nice: true,
//     alias: '行业讨论热度增长值',
//     // formatter(value) {
//     //   return `${value}万`;
//     // },
//   },
// };
// const symbol: MarkerCallback = (x: number, y: number) => {
//   const r = 2;
//   return [
//     ['M', x - 4 * r, y],
//     ['L', x + 4 * r, y],
//     ['M', x - r, y],
//     ['A', r, r, 0, 0, 0, x + r, y],
//     ['A', r, r, 0, 0, 0, x - r, y],
//   ];
// };
const controller = new ConHomeWebController();
export type IndustryInfoProps = {
  industryLabelList?: ConHomeIndustryHeader[];
};
const IndustryInfo: React.FC<IndustryInfoProps> = ({ industryLabelList = [] }) => {
  const [selectedLabel, setSelectedLabel] = useState<ConHomeIndustryHeader>(industryLabelList?.[0]);
  const { token } = useSelector<RootState, RootState['user']>(state => state.user);
  const { data } = useRequest(
    async () => {
      const { data } = await controller.conHomeWebControllerV1HomeIndustryDataInfoUsingGet1({
        industryTrackId: selectedLabel?.conIndustryTrackId,
      });
      const { conIndustryScaleInfo = {}, traditionalMediaTalkList = [], socialMediaTalkList = [] } = data.data;
      const scaleListData = conIndustryScaleInfo?.conIndustryScaleChartVoList
        .sort((a, b) => {
          return a.countTimeYear - b.countTimeYear;
        })
        .map(item => {
          return {
            ...item,
            countTimeMonth: '' + item.countTimeMonth,
            countTimeYear: '' + item.countTimeYear,
            dataTypeName: '行业消费规模',
          };
        });
      const discussionValueData = traditionalMediaTalkList
        ?.map(item => {
          return {
            ...item,
            type: '传统媒体讨论热度',
            countTimeMonth: '' + item.countTimeMonth,
          };
        })
        .concat(
          socialMediaTalkList?.map(item => {
            return {
              ...item,
              type: '社交媒体讨论热度',
              countTimeMonth: '' + item.countTimeMonth,
            };
          })
        );
      const increateRateData = traditionalMediaTalkList
        ?.map(item => {
          return {
            ...item,
            type: '传统媒体环比',
            countTimeMonth: '' + item.countTimeMonth,
          };
        })
        .concat(
          socialMediaTalkList?.map(item => {
            return {
              ...item,
              type: '社交媒体环比',
              countTimeMonth: '' + item.countTimeMonth,
            };
          })
        );
      return { ...data.data, scaleListData, discussionValueData, increateRateData };
    },
    {
      refreshDeps: [selectedLabel?.conIndustryTrackId],
    }
  );
  const scale: IChartProps['scale'] = useMemo(
    () =>
      data?.discussionValueData?.length === 1
        ? {
            countTimeYear: {
              type: 'cat',
              alias: '年份',
              formatter(value) {
                return `${value}年`;
              },
            },
            increaseVaue: {
              type: 'linear',
              min: data.discussionValueData?.[0].increaseRateValue - 5,
              max: data.discussionValueData?.[0].increaseRateValue + 5,
              tickCount: 2,
              nice: true,
              alias: '规模同比',
              formatter(value) {
                return `${value}%`;
              },
            },
            scaleValue: {
              type: 'linear',
              //   tickCount: 2,
              nice: true,
              alias: '行业消费规模',
              // formatter(v) {
              //   const { unit, value } = formatNumberValueToChineseUnit(v, 2);
              //   return `${value}${unit}`;
              // },
            },
          }
        : {
            countTimeYear: {
              type: 'cat',
              alias: '年份',
              formatter(value) {
                return `${value}年`;
              },
            },
            increaseVaue: {
              type: 'linear',
              // min: 0,
              // max: 100,
              // tickCount: 2,
              nice: true,
              alias: '规模同比',
              formatter(value) {
                return `${value}%`;
              },
            },
            scaleValue: {
              type: 'linear',
              //   tickCount: 2,
              nice: true,
              alias: '行业消费规模',
              // formatter(v) {
              //   const { unit, value } = formatNumberValueToChineseUnit(v, 2);
              //   return `${value}${unit}`;
              // },
            },
          },
    [data?.discussionValueData]
  );
  const cloutScale: IChartProps['scale'] = useMemo(
    () =>
      data?.increateRateData?.length === 1
        ? {
            countTimeMonth: {
              type: 'cat',
              alias: '月份',
              sync: true,
              formatter(value) {
                return `${value}月`;
              },
            },
            increaseRateValue: {
              type: 'linear',
              min: data?.increateRateData?.[0]?.increaseRateValue - 5,
              max: data?.increateRateData?.[0]?.increaseRateValue + 5,
              tickCount: 2,
              nice: true,
              alias: '行业讨论热度环比',
              formatter(value) {
                // console.log(value);
                return `${value}%`;
              },
            },
            discussValue: {
              type: 'linear',
              //   tickCount: 2,
              nice: true,
              alias: '行业讨论热度增长值',
              // formatter(value) {
              //   return `${value}万`;
              // },
            },
          }
        : {
            countTimeMonth: {
              type: 'cat',
              alias: '月份',
              sync: true,
              formatter(value) {
                return `${value}月`;
              },
            },
            increaseRateValue: {
              type: 'linear',
              // min: 0,
              // max: 100,
              tickCount: 2,
              nice: true,
              alias: '行业讨论热度环比',
              formatter(value) {
                // console.log(value);
                return `${value}%`;
              },
            },
            discussValue: {
              type: 'linear',
              //   tickCount: 2,
              nice: true,
              alias: '行业讨论热度增长值',
              // formatter(value) {
              //   return `${value}万`;
              // },
            },
          },
    [data?.increateRateData]
  );
  return (
    <>
      <ChartHeader
        title="行业趋势"
        titleFontSize={20}
        extra={
          <div className={styles.labelTabList}>
            <div className={styles.labelTabListL}>
              {industryLabelList.map((item, index) => {
                return (
                  <IndustryLabel
                    key={item.conHomeIndustryShowId}
                    name={item.industryTrackName}
                    selected={item.conHomeIndustryShowId === selectedLabel.conHomeIndustryShowId}
                    locked={!token && !!index}
                    className={styles.industryLabel}
                    onClick={() => {
                      setSelectedLabel(item);
                    }}
                  />
                );
              })}
            </div>
            <div className={styles.labelTabListR}>统计周期 {data?.updateTimeStr}</div>
          </div>
        }
      />

      {/*<Chart*/}
      {/*  title={*/}
      {/*    <h1 className={styles.moduleTitle}>*/}
      {/*      行业增长力综合指数*/}
      {/*      <TooltipBase*/}
      {/*        title={*/}
      {/*          <>*/}
      {/*            <p>*/}
      {/*              增长力综合指数：由行业及赛道下所有品牌的行业发展潜力、组织能力、产品竞争能力、供应链管理能力、用户发展能力、营销能力和经营能力7个维度搭建的数学模型计算得出，用于反映行业及赛道的综合实力与增长潜力。*/}
      {/*            </p>*/}
      {/*            <p>行业发展潜力：由行业成长空间、行业融资环境、行业讨论热度等维度搭建的数学模型计算得出。</p>*/}
      {/*            <p>组织能力：由行业下所有品牌的公司实力、核心团队能力等维度搭建的数学模型计算得出。</p>*/}
      {/*            <p>产品竞争能力：由行业下所有品牌的研发创新能力、爆品打造能力等维度搭建的数学模型计算得出。</p>*/}
      {/*            <p>供应链管理能力：由行业下所有品牌的供应链完善度、物流配送效率等维度搭建的数学模型计算得出。</p>*/}
      {/*            <p>用户发展能力：由行业下所有品牌的用户群拓展能力、社交媒体热度等维度搭建的数学模型计算得出。</p>*/}
      {/*            <p>营销能力：由行业下所有品牌的品牌内容量、互动量等维度搭建的数学模型计算得出。</p>*/}
      {/*            <p>经营能力：由行业下所有品牌的经营规模、经营增长能力等维度搭建的数学模型计算得出。</p>*/}
      {/*          </>*/}
      {/*        }*/}
      {/*        // placement="right"*/}
      {/*      />*/}
      {/*    </h1>*/}
      {/*  }*/}
      {/*  dateSubTitle={true}*/}
      {/*  date={data?.updateTimeStr}*/}
      {/*  subTitleFontColor="#aaa"*/}
      {/*  panelClassName={styles.compositeIndexChart}*/}
      {/*>*/}
      {/*  <div className={styles.industryCompositeIndexChartContent}>*/}
      {/*    <IndustryCompositeIndexList*/}
      {/*      className={styles.industryCompositeIndexListContent}*/}
      {/*      data={data?.conIndustryCompositeVoList}*/}
      {/*    />*/}
      {/*    <div*/}
      {/*      className={*/}
      {/*        data?.conIndustryRises.length*/}
      {/*          ? styles.racetrackCompositeIndexROIChartContent*/}
      {/*          : styles['racetrackCompositeIndexROIChartContent--empty']*/}
      {/*      }*/}
      {/*    >*/}
      {/*      {!!data?.conIndustryRises.length ? (*/}
      {/*        data?.conIndustryRises.slice(0, 6).map(item => {*/}
      {/*          return (*/}
      {/*            <RacetrackCompositeIndexROICard*/}
      {/*              className={styles.ROICard}*/}
      {/*              key={item.conIndustryRiseId}*/}
      {/*              title={item.oneLevelTrackName}*/}
      {/*              value={item.compositeChangeValue}*/}
      {/*            />*/}
      {/*          );*/}
      {/*        })*/}
      {/*      ) : (*/}
      {/*        <CustomEmpty />*/}
      {/*      )}*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*</Chart>*/}
      <div className={styles.chartContainer}>
        <Chart
          title={
            <h1 className={styles.moduleTitle}>
              行业消费规模
              <TooltipBase
                title={
                  <>
                    <p>通过行业的消费规模反映行业增长空间与前景，数据已做脱敏处理。</p>
                    <p>数据来源：CBNData数据库</p>
                  </>
                }
                placement="right"
              />
            </h1>
          }
          subTitleFontColor="#aaa"
          panelClassName={styles.industryScaleChart}
        >
          {data?.industryScaleShowChartStatus && (
            <LineAndBarMixedChart
              barChartData={data?.scaleListData}
              // lineChartData={data?.scaleListData}
              scale={scale}
              // formatToChineseUnit
              xAxisName="countTimeYear"
              yAxisNameOfBarChart="scaleValue"
              // yAxisOfBarChartProps={{
              //   label: {
              //     formatter(v) {
              //       const { unit, value } = formatNumberValueToChineseUnit(+v * 1e4);
              //       return `${value}${unit}`;
              //     },
              //   },
              // }}
              yAxisNameOfLineChart="increaseVaue"
              legendProps={{
                // custom: true,
                padding: [14, 0, 19, 0],
                // items: [
                //   { name: '行业消费规模', value: 'scaleValue', marker: { symbol: 'square', style: { fill: '#ffc4b2' } } },
                //   {
                //     name: '行业消费规模同比',
                //     value: 'increaseVaue',
                //     marker: {
                //       symbol,
                //       style: {
                //         stroke: '#f75c2f',
                //         lineWidth: 2,
                //         fill: '#f75c2f',
                //       },
                //     },
                //   },
                // ],
                // onChange(e, chart) {
                //   const item = e.item;
                //   const value = item.value;
                //   const checked = !item.unchecked;
                //   const geoms = chart.geometries;

                //   for (let i = 0; i < geoms.length; i++) {
                //     const geom = geoms[i];
                //     if (geom.getYScale().field === value) {
                //       if (checked) {
                //         geom.show();
                //       } else {
                //         geom.hide();
                //       }
                //     }
                //   }
                // },
              }}
              barChartGroupBy="dataTypeName"
              intervalColor="#ffc4b2"
              interverProps={{ size: 16, shape: 'border-radius' }}
              // interverProps={{ size: 16, color: '#ffc4b2', shape: 'border-radius' }}
              lineProps={{ color: '#f75c2f' }}
              pointProps={{ size: 3, color: '#f75c2f' }}
            />
          )}
          {/* <div className={styles.panelList}>
            {data?.conIndustryScaleInfo.conIndustryScaleList.map(item => {
              return (
                <IndustryScaleMoMRatioPanelVersionTwo
                  className={styles.scaleMoMRationPanel}
                  key={item.conIndustryScaleId}
                  industryName={selectedLabel.industryTrackName}
                  year={item.countTimeYear}
                  type={item.increaseType}
                  value={item.increaseVaue}
                />
              );
            })}
          </div> */}
          {/* <div
            className={classnames(styles.panelList, {
              [styles['panelList--collapse']]: data?.industryScaleShowChartStatus,
            })}
          >
            {data?.conIndustryScaleInfo.conIndustryScaleList.map(item => {
              return (
                <IndustryScaleMoMRatioPanelVersionTwo
                  key={item.conIndustryScaleId}
                  industryName={selectedLabel.industryTrackName}
                  year={item.countTimeYear}
                  type={item.increaseType}
                  value={item.increaseVaue}
                />
              );
            })}
          </div> */}
        </Chart>
        <Chart
          title={
            <h1 className={styles.moduleTitle}>
              行业讨论热度趋势
              <TooltipBase
                title={
                  <>
                    <p>
                      通过传统媒体平台以及社交媒体平台中的行业正向资讯数量反映行业的讨论热度趋势，数据已做脱敏处理。
                    </p>
                    <p>数据源：新浪舆情通</p>
                  </>
                }
                placement="right"
              />
            </h1>
          }
          subTitleFontColor="#aaa"
          panelClassName={styles.industryDiscussionCloutChart}
        >
          {data?.industryTalkShowChartStatus && (
            <LineAndBarMixedChart
              barChartData={data?.discussionValueData}
              // lineChartData={data?.increateRateData}
              xAxisName="countTimeMonth"
              yAxisNameOfBarChart="discussValue"
              // yAxisOfBarChartProps={{
              //   label: {
              //     formatter(v) {
              //       const { unit, value } = formatNumberValueToChineseUnit(+v * 1e4);
              //       return `${value}${unit}`;
              //     },
              //   },
              // }}
              yAxisNameOfLineChart="increaseRateValue"
              scale={cloutScale}
              // formatToChineseUnit
              barChartGroupBy="type"
              // lineChartGroupBy="type"
              legendProps={{
                padding: [14, 0, 19, 0],
                name: 'type',
                items: [
                  {
                    name: '传统媒体讨论热度',
                    value: '传统媒体讨论热度',
                    marker: {
                      symbol: 'square',
                      style: { fill: '#f75c2f' },
                    },
                  },
                  {
                    name: '社交媒体讨论热度',
                    value: '社交媒体讨论热度',
                    marker: {
                      symbol: 'square',
                      style: { fill: '#ffc4b2' },
                    },
                  },
                  // {
                  //   name: '传统媒体环比',
                  //   value: '传统媒体环比',
                  //   marker: {
                  //     symbol,
                  //     style: {
                  //       stroke: '#666',
                  //       lineWidth: 2,
                  //       fill: '#666',
                  //     },
                  //   },
                  // },
                  // {
                  //   name: '社交媒体环比',
                  //   value: '社交媒体环比',
                  //   marker: {
                  //     symbol,
                  //     style: {
                  //       stroke: '#aaa',
                  //       lineWidth: 2,
                  //       fill: '#aaa',
                  //     },
                  //   },
                  // },
                ],
              }}
              interverProps={{ shape: 'border-radius' }}
              lineColor={['#666', '#aaa']}
              intervalColor={['#f75c2f', '#ffc4b2']}
              pointProps={{ size: 3 }}
            />
          )}
          {/* <div className={styles.panelList}>
            {data?.traditionalMediaTalkList.map((item, index) => {
              const socialMedia = data?.socialMediaTalkList[index];
              return (
                <IndustryDiscussionCloutMoMRatioPanelVersionTwo
                  className={styles.discussionCloutPanel}
                  key={item.conIndustryTalkId}
                  industryName={selectedLabel.industryTrackName}
                  month={item.countTimeMonth}
                  traditionMedia={{ type: item.increaseType, value: item.increaseRateValue }}
                  socialMedia={{ type: socialMedia.increaseType, value: socialMedia.increaseRateValue }}
                />
              );
            })}
          </div> */}
          {/* <div
            className={classnames(styles.panelList, {
              [styles['discussionCloutPanelList--collapse']]: data?.industryTalkShowChartStatus,
            })}
          >
            {data?.traditionalMediaTalkList.map((item, index) => {
              const socialMedia = data?.socialMediaTalkList[index];
              return (
                <IndustryDiscussionCloutMoMRatioPanelVersionTwo
                  className={styles.discussionCloutPanel}
                  key={item.conIndustryTalkId}
                  industryName={selectedLabel.industryTrackName}
                  month={item.countTimeMonth}
                  traditionMedia={{ type: item.increaseType, value: item.increaseRateValue }}
                  socialMedia={{ type: socialMedia.increaseType, value: socialMedia.increaseRateValue }}
                />
              );
            })}
          </div> */}
        </Chart>
      </div>
    </>
  );
};

export default IndustryInfo;
